import { Fragment } from 'react';
import { Text, UnstyledButton } from '@mantine/core';
import { IconCirclePlus } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  participantNames: string[];
  onOpen?: () => void;
  radius?: number;
  textSize?: string;
  nameColor?: string;
  iconSize?: number;
  px?: string;
  py?: string;
  gap?: number;
};

export function ParticipantPill({
  participantNames,
  onOpen,
  radius = 8,
  textSize = 'textXs',
  nameColor = 'gray.7',
  iconSize = 16,
  px = 'xxs',
  py = 'xxxs',
  gap = 4,
}: Props) {
  return (
    <UnstyledButton
      onClick={onOpen}
      bg="gray.1"
      py={py}
      px={px}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap,
        borderRadius: radius,
      }}
    >
      <Text component="span" size={textSize} fw={FONT_WEIGHTS.medium} c="gray.7">
        with{' '}
        {participantNames.map((name, index) => (
          <Fragment key={name}>
            <Text
              component="span"
              size={textSize}
              fw={FONT_WEIGHTS.medium}
              c={nameColor}
              style={{ textDecoration: 'underline dotted', textUnderlineOffset: 2 }}
            >
              {name}
            </Text>
            {index < participantNames.length - 1 ? ', ' : ''}
          </Fragment>
        ))}
      </Text>
      <IconCirclePlus size={iconSize} color="var(--mantine-color-gray-7)" />
    </UnstyledButton>
  );
}
